import React, { useEffect, useState } from 'react';
import { avatarDataUri } from '@designwithfriends/avatar/render';
import { config } from '../../config';

// The public item list the apps draw from, fetched once per page load.
let itemsPromise = null;
const loadItems = () => {
    itemsPromise ??= fetch(`${config().catalogueServiceBaseUrl}/avatar/items`)
        .then((res) => (res.ok ? res.json() : { items: [] }))
        .then((body) => new Map(body.items.map((item) => [item.id, item])))
        .catch(() => new Map());
    return itemsPromise;
};

/**
 * A designer's generated avatar (or their provider photo when they opted in),
 * as the apps draw it. Pass `items` to draw against a specific item list (the
 * item form's preview); otherwise the live list is used.
 */
export function DesignerAvatar({ avatar, photoURL, items, size = 32 }) {
    const [liveItems, setLiveItems] = useState(null);

    useEffect(() => {
        if (items) return undefined;
        let mounted = true;
        loadItems().then((loaded) => { if (mounted) setLiveItems(loaded); });
        return () => { mounted = false; };
    }, [items]);

    const style = { width: size, height: size, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 };
    if (photoURL) return <img src={photoURL} alt="" referrerPolicy="no-referrer" style={style} />;
    if (!avatar) return <span style={{ ...style, display: 'inline-block', background: '#eee' }} />;
    return <img src={avatarDataUri(avatar, items ?? liveItems)} alt="" style={style} />;
}
